module.exports = "/_next/static/images/a55a14857d01f41dc9c1374febb22114-man-sitting-with-notebook@lg-2x.jpg";